"use strict";

import angular from "angular";
import { Company } from "../../../gateway/Company/Company";

angular.module("nucont.accounting.companyCreate").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.create-company", {
            url: "/criar-empresa?page",
            params: { page: { value: null, dynamic: true } },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-create" */ "./company-create.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.companyCreate"));
            },
            views: {
                "admin@nucont.accounting": {
                    component: "companyCreateComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "closeTimes.enabled",
                            value: true
                        },
                        {
                            object: "headerConfig",
                            path: "featureNews.enabled",
                            value: false
                        },
                        {
                            object: "headerConfig",
                            path: "helpCentral.enabled",
                            value: false
                        }
                    ]
                }
            },
            resolve: {
                companyData: [
                    () => {
                        return {};
                    }
                ]
            }
        })
        .state("nucont.accounting.edit-company", {
            url: "/:id/editar-empresa",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-create" */ "./company-create.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.companyCreate"));
            },
            views: {
                "admin@nucont.accounting": {
                    component: "companyCreateComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            },
            resolve: {
                companyData: [
                    "$stateParams",
                    async ($stateParams) => {
                        const CompanyDomain = new Company();
                        const companies = await CompanyDomain.getByIds([
                            $stateParams.id
                        ]);
                        const company = companies[0];
                        return company;
                    }
                ]
            }
        });
}
